var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { gql } from '@apollo/client';
import { DateTime } from 'luxon';
import { getDurationStr, getTimeIntervalStr } from '@amzn/atoz-shiftapp-utilities';
import { useAcceptVto } from '../../../hooks';
export var useSelectVtoModalContentData = function (_a) {
    var scheduleShift = _a.scheduleShift, close = _a.close, setModalContent = _a.setModalContent, setModalError = _a.setModalError, vtoOpportunities = _a.vtoOpportunities;
    var _b = React.useState(vtoOpportunities[0]), selectedVTO = _b[0], setSelectedVTO = _b[1];
    var vtoRadioOptionsProps = vtoOpportunities.map(function (vtoOpportunity) {
        var durationStr = getDurationStr(vtoOpportunity.shift.duration);
        var intervalStr = getTimeIntervalStr(DateTime.fromISO(vtoOpportunity.shift.timeRange.start), DateTime.fromISO(vtoOpportunity.shift.timeRange.end));
        return {
            checked: vtoOpportunity.id === selectedVTO.id,
            name: 'VTORadioOptions',
            titleText: "".concat(intervalStr, " (").concat(durationStr, ")"),
            onChange: function () {
                setSelectedVTO(vtoOpportunity);
            }
        };
    });
    var _c = useAcceptVto({
        vtoOpportunity: selectedVTO,
        setModalContent: setModalContent,
        setModalError: setModalError
    }), acceptVtoMutation = _c.acceptVtoMutation, loading = _c.useAcceptVtoState.loading;
    return {
        vtoRadioOptionsProps: vtoRadioOptionsProps,
        acceptVtoIsSubmitting: loading,
        onClickSelect: acceptVtoMutation,
        close: close
    };
};
useSelectVtoModalContentData.fragments = {
    shiftOpportunity: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        fragment UseSelectVtoModalContentData_ShiftOpportunity on ShiftOpportunity {\n            id\n            shift {\n                duration {\n                    value\n                }\n                timeRange {\n                    start\n                    end\n                }\n            }\n            type\n            ...useAcceptVto_ShiftOpportunity\n        }\n\n        ", "\n    "], ["\n        fragment UseSelectVtoModalContentData_ShiftOpportunity on ShiftOpportunity {\n            id\n            shift {\n                duration {\n                    value\n                }\n                timeRange {\n                    start\n                    end\n                }\n            }\n            type\n            ...useAcceptVto_ShiftOpportunity\n        }\n\n        ", "\n    "])), useAcceptVto.fragments.shiftOpportunity),
    scheduleShift: gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        fragment UseSelectVtoModalContentData_ScheduleShift on ScheduleShift {\n            shift {\n                timeRange {\n                    start\n                    end\n                }\n            }\n        }\n    "], ["\n        fragment UseSelectVtoModalContentData_ScheduleShift on ScheduleShift {\n            shift {\n                timeRange {\n                    start\n                    end\n                }\n            }\n        }\n    "])))
};
var templateObject_1, templateObject_2;
